import React from 'react';
import { Control, Controller, FieldError } from 'react-hook-form';
import Dropdown from './Dropdown';

interface StatusSelectProps {
  label?: string;
  name: string;
  control: Control<any>;
  error?: FieldError;
  required?: boolean;
  appendTo?: string;
}

const StatusSelect: React.FC<StatusSelectProps> = ({
  label,
  name,
  control,
  error,
  required = true,
  appendTo = 'body',
}) => {
  const options = [
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' },
  ];

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => (
        <Dropdown
          label={label || 'Status'}
          value={value}
          setValue={onChange}
          options={options}
          labelKey="label"
          valueKey="value"
          required={required}
          error={error}
          formMode={false}
          isCreatable={false}
          appendTo={appendTo}
        />
      )}
    />
  );
};

export default StatusSelect;
